package com.elan.edubridge.shared.domain

/**
 * 콜백 구독의 취소 핸들.
 *
 * `Flow`가 ObjC 헤더로 브리징되지 않기 때문에 존재한다. Swift가 구현하거나 소비해야 하는
 * 스트림은 `onEach` 콜백 + 이 핸들 형태로 나가고, Swift는 `AsyncStream`으로 감싼 뒤
 * `onTermination`에서 [cancel]을 부른다. Android·웹은 이 핸들을 `callbackFlow`의
 * `awaitClose`에서 부른다.
 *
 * **생성자가 public인 이유**: `apps/android`·`apps/web`은 별도 Gradle 모듈이라 `internal`이면
 * 플랫폼 datasource가 자기 리스너 등록을 감쌀 수 없다.
 *
 * **`presentation`이 아니라 `domain`에 있는 이유**: 이제 `data.datasource`가 이 타입을
 * 반환한다. `presentation`에 두면 데이터 계층이 표현 계층을 import하게 된다.
 *
 * ⚠️ Swift에서 이 타입은 `Cancellable`로 보이고 **`Combine.Cancellable`과 이름이 겹친다.**
 * iOS는 Combine을 쓰지 않는 것으로 정리했고, 이 충돌이 그 결정의 근거 중 하나다.
 */
class Cancellable(private val onCancel: () -> Unit) {
    fun cancel() {
        onCancel()
    }
}
